import { useState } from 'react'
import Action from "./Action"

import { HiOutlineKey } from "react-icons/hi"

function clickButton(password, permanent, setPassword, flash, lang)
{
    if (password !== "") {
        setPassword(password, permanent)
    } else {
        flash.putMessage(lang.tr("please_enter_master_password"), "warning")
    }
}

function PasswordForm({setPassword, flash, lang})
{
    const [localPassword, setLocalPassword] = useState("")
    const [localPermanent, setLocalPermanent] = useState(false)
    const confirmFunction = () => clickButton(localPassword, localPermanent, setPassword, flash, lang)
    return (
        <div>
            <div className="password">
                <div className='master-password-key'>
                    <div className='password-input'>
                        <input
                            type="password"
                            placeholder={lang.tr("enter_master_password")}
                            value={localPassword}
                            onChange={e => setLocalPassword(e.target.value)}
                            onKeyPress={(e) => ((e.keyCode || e.which) == 13) ? confirmFunction() : undefined}
                        />
                    </div>
                    <div className='password-key'>
                        <Action action={confirmFunction} title={lang.tr("set_master_password")}><HiOutlineKey /></Action>
                    </div>
                </div>
            </div>
            <div className="permanent-check">
                <label>
                    <input
                        type="checkbox"
                        checked={localPermanent}
                        onChange={e => setLocalPermanent(e.target.checked ? true : false)} 
                        onKeyPress={(e) => ((e.keyCode || e.which) == 13) ? confirmFunction() : undefined}
                    />
                    {lang.tr("store_password_permanently")}
                </label>
            </div>
        </div>
    )
}

export default PasswordForm
